import { render, staticRenderFns } from "./GroupListAddNew.vue?vue&type=template&id=56ce068a&"
import script from "./GroupListAddNew.vue?vue&type=script&lang=js&"
export * from "./GroupListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./GroupListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports